import { CaseReducer, PayloadAction } from "@reduxjs/toolkit";
import { ProductSectionState } from "./store";
import { ProductSectionView } from "AssortmentOverview/ProductSection/types";
import { ActionSectionIcons } from "AssortmentOverview/ProductSection/Header/ActionSection/types";
import { ProductListRow } from "ProductList/types";

const setActiveView: CaseReducer<
  ProductSectionState["productSection"],
  PayloadAction<ProductSectionView>
> = (prevState, action) => {
  return {
    ...prevState,
    activeView: action.payload,
    // always disable when view changes
    deleteProductsEnabled: false,
  };
};

const toggleDoorsModal: CaseReducer<ProductSectionState["productSection"]> = (
  prevState
) => {
  return {
    ...prevState,
    shouldShowDoorsModal: !prevState.shouldShowDoorsModal,
  };
};

const toggleImportModal: CaseReducer<ProductSectionState["productSection"]> = (
  prevState
) => ({
  ...prevState,
  shouldShowImportModal: !prevState.shouldShowImportModal,
});

const enableDeleteProducts: CaseReducer<
  ProductSectionState["productSection"],
  PayloadAction<boolean>
> = (prevState, action) => ({
  ...prevState,
  deleteProductsEnabled: action.payload,
});

const enableWorkspaceAssistant: CaseReducer<
  ProductSectionState["productSection"],
  PayloadAction<boolean>
> = (prevState, action) => ({
  ...prevState,
  workspaceAssistantEnabled: action.payload,
});

const setSelectedRows: CaseReducer<
  ProductSectionState["productSection"],
  PayloadAction<any[]>
> = (prevState, action) => ({
  ...prevState,
  selectedRows: action.payload,
});

const setRowsDeleted: CaseReducer<
  ProductSectionState["productSection"],
  PayloadAction<any[]>
> = (prevState, action) => ({
  ...prevState,
  rowsDeleted: action.payload,
});

const setDisabledAction: CaseReducer<
  ProductSectionState["productSection"],
  PayloadAction<ActionSectionIcons>
> = (prevState, action) => {
  const { disabledActions: prevDisabledActions } = prevState;
  const deduplicatedDisabledActions = new Set([
    ...prevDisabledActions,
    action.payload,
  ]);
  return { ...prevState, disabledActions: [...deduplicatedDisabledActions] };
};

const setEnabledAction: CaseReducer<
  ProductSectionState["productSection"],
  PayloadAction<ActionSectionIcons>
> = (prevState, action) => {
  const { disabledActions: prevDisabledActions } = prevState;
  const filteredDisabledActions = prevDisabledActions.filter(
    (item) => item !== action.payload
  );
  return { ...prevState, disabledActions: filteredDisabledActions };
};

const setNewStyleColorRows: CaseReducer<
  ProductSectionState["productSection"],
  PayloadAction<ProductListRow[]>
> = (prevState, action) => ({
  ...prevState,
  newStyleColorRows: action.payload,
});

const reducers = {
  setActiveView,
  toggleDoorsModal,
  toggleImportModal,
  setDisabledAction,
  setEnabledAction,
  enableDeleteProducts,
  enableWorkspaceAssistant,
  setSelectedRows,
  setRowsDeleted,
  setNewStyleColorRows,
};

export default reducers;
